export let gallery = {
"Pisos": [
"Frame 1",
"Frame 2",
"Frame 3",
"Frame 4",
],
}